import {create} from 'zustand';
import { getEngagement } from '../api_layer/api';
import { getTeam } from '../api_layer/api';

const useEngagementStore = create((set) => ({
  engagementData: [],
  teamData:[],
  isLoading: false,
  error: null,
  fetchEngData: async (sd,ed) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getEngagement(sd,ed);
      set({ engagementData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  fetchTeamData: async () => {
    try {
      set({ isLoading: true, error: null });
      const response = await getTeam();
      set({teamData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export default useEngagementStore;